import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './SignUp.css';

// ─── EmailJS Configuration ───────────────────────────────────────
// 1. Create a free account at https://www.emailjs.com
// 2. Add an email service (Gmail, etc.) → copy the Service ID
// 3. Create an email template with variables: {{user_email}} and {{to_email}}
//    - Set the "To Email" field to: {{to_email}}
//    - Set the subject to something like: "New Saving Grace Chapter Request"
//    - Set the body to: "New signup from: {{user_email}}"
// 4. Copy your Public Key from Account → General
// 5. Replace the values below:
const EMAILJS_SERVICE_ID = 'service_83uvj15';
const EMAILJS_TEMPLATE_ID = 'template_yxujh3h';
const EMAILJS_PUBLIC_KEY = 'aFmClkyRgn5G-hZdn';
// ─────────────────────────────────────────────────────────────────

function SignUp() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error' | 'sending'
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef();

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setStatus('error');
      setErrorMsg('Please enter your email address.');
      return;
    }

    if (!isValidEmail(email)) {
      setStatus('error');
      setErrorMsg('Please enter a valid email address.');
      return;
    }

    setStatus('sending');
    setErrorMsg('');

    emailjs
      .send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          user_email: email,
          to_email: 'junnnnbug@gmail.com',
        },
        EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setStatus('success');
        setEmail('');
      })
      .catch(() => {
        setStatus('error');
        setErrorMsg('Something went wrong. Please try again.');
      });
  };

  return (
    <section className="signup-section" id="signup">
      <div className="signup-inner reveal">
        <h2>READ CHAPTER ONE FREE</h2>
        <p className="sub">
          Enter your email below and get the opening chapter of Saving Grace delivered to your inbox instantly.
        </p>

        {status === 'success' ? (
          <div className="signup-success">
            <p className="success-msg">
              Thank you! Your free chapter of <strong>Saving Grace</strong> will arrive in your inbox shortly.
            </p>
          </div>
        ) : (
          <form ref={formRef} className="signup-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status === 'error') setStatus(null);
              }}
              className={status === 'error' ? 'input-error' : ''}
            />
            <button type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'SENDING...' : 'SEND IT'}
            </button>
          </form>
        )}

        {status === 'error' && errorMsg && (
          <p className="signup-error">{errorMsg}</p>
        )}

        {status !== 'success' && (
          <p className="signup-note">No spam, ever. Unsubscribe anytime.</p>
        )}
      </div>
    </section>
  );
}

export default SignUp;
